import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, Link2, X } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const lei = (v) => `${(v ?? 0).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} lei`;
const fmtD = (iso) => (iso ? `${iso.slice(8, 10)}.${iso.slice(5, 7)}.${iso.slice(0, 4)}` : '—');

// Alege rândul Saga cu care se împerechează un document introdus manual (când numărul documentului nu s-a potrivit automat)
export default function SagaLinkPicker({ facturaId, onLinked, onCancel }) {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    axios.get(`${API_URL}/furnizori/facturi/${facturaId}/candidati-saga`, auth()).then((r) => setRows(r.data)).catch(() => { toast.error('Nu s-au putut încărca rândurile Saga'); setRows([]); });
  }, [facturaId]);

  const link = async (s) => {
    if (!window.confirm(`Legi documentul manual de rândul Saga ${s.nr_intrare} (${lei(s.total)}, ${fmtD(s.data)})? Documentul tău preia datele Saga; rândul Saga nu va mai apărea separat.`)) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API_URL}/furnizori/facturi/${facturaId}/leaga`, { saga_id: s.id }, auth());
      toast.success('Împerecheat cu Saga');
      if (r.data.warning) toast.warning(r.data.warning, { duration: 10000 });
      onLinked?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Eroare'); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-lg border bg-slate-50 p-3 space-y-2" data-testid="saga-link-picker">
      <div className="flex items-center justify-between">
        <div className="text-sm font-semibold flex items-center gap-1.5"><Link2 className="w-4 h-4" /> Leagă de documentul Saga</div>
        <Button type="button" size="icon" variant="ghost" className="h-7 w-7" onClick={onCancel} data-testid="saga-link-cancel"><X className="w-4 h-4" /></Button>
      </div>
      {rows === null ? <div className="text-xs text-slate-500 flex items-center gap-1"><Loader2 className="w-3 h-3 animate-spin" /> Se încarcă...</div>
        : rows.length === 0 ? <p className="text-xs text-slate-500">Acest furnizor nu are încă rânduri importate din Saga.</p> : (
        <div className="max-h-64 overflow-y-auto divide-y rounded border bg-white">
          {rows.map((s) => (
            <button key={s.id} type="button" disabled={busy} onClick={() => link(s)} className="w-full text-left px-3 py-2 text-xs flex flex-wrap items-center gap-x-3 hover:bg-blue-50 disabled:opacity-50" data-testid={`saga-link-candidate-${s.id}`}>
              <span className="font-mono font-medium">{s.nr_intrare}</span>
              <span className="text-slate-500">{fmtD(s.data)}</span>
              <span className="font-semibold">{lei(s.total)}</span>
              {s.nr_plati > 0 && <span className="text-green-700">plătit {lei(s.platit)}</span>}
              {s.neachitat > 0 && <span className="text-slate-400">Saga neachitat {lei(s.neachitat)}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
